<template>
  <div class="notifications-page">
    <v-container>
      <SectionHeader title="Notifikace" />

      <div class="text-right mb-6">
        <ButtonElement
          text="Připravit notifikaci"
          icon="bell-plus-outline"
          color="primary"
          @click="showFormDialog = true"
        />
      </div>

      <PreparedNotificationsTable ref="preparedTable" class="mb-12" @sent="onNotificationSent" />

      <SentNotificationsTable ref="sentTable" />

      <AppDialog
        :show-dialog="showFormDialog"
        title="Připravit notifikaci"
        hide-actions
        @closeDialog="closeFormDialog"
      >
        <NotificationForm @submitted="onFormSubmitted" @close="closeFormDialog" />
      </AppDialog>
    </v-container>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';
import ButtonElement from '@/components/elements/ButtonElement.vue';
import AppDialog from '@/components/elements/AppDialog.vue';
import NotificationForm from '@/components/forms/NotificationForm.vue';
import PreparedNotificationsTable from '@/components/table/PreparedNotificationsTable.vue';
import SentNotificationsTable from '@/components/table/SentNotificationsTable.vue';

export default {
  name: 'NotificationsPage',

  components: {
    SectionHeader,
    ButtonElement,
    AppDialog,
    NotificationForm,
    PreparedNotificationsTable,
    SentNotificationsTable,
  },

  data() {
    return {
      showFormDialog: false,
    };
  },

  methods: {
    closeFormDialog() {
      this.showFormDialog = false;
    },

    onFormSubmitted() {
      this.showFormDialog = false;
      this.$refs.preparedTable.fetchData();
    },

    onNotificationSent() {
      this.$refs.sentTable.refresh();
    },
  },
};
</script>
